export type ServicesConfig = {
  apiKey?: string
  baseUrl?: string
  accessTokenUrl?: string
  accessTokenKey?: string
}

const serviceConfig = {
  apiKey: process.env.REWARD_PLATFORM_API_KEY,
  baseUrl: process.env.REWARD_PLATFORM_BASE_URL,
  accessTokenUrl: process.env.IAGL_ACCESS_TOKEN_URL,
  accessTokenKey: process.env.IAGL_INTERNAL_BASIC_AUTH_ENCODED_STRING,
}

export const getServicesConfig = (): ServicesConfig => {
  return serviceConfig
}
